import { render, staticRenderFns } from "./ECollapse.vue?vue&type=template&id=997a9336&scoped=true&"
import script from "./ECollapse.vue?vue&type=script&lang=js&"
export * from "./ECollapse.vue?vue&type=script&lang=js&"
import style0 from "./ECollapse.vue?vue&type=style&index=0&id=997a9336&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997a9336",
  null
  
)

export default component.exports